import { TFunction } from "react-i18next";
import { OrganizationProductPerCategoryApi } from "../../../../../../services/Api/types";

export const getProductCategoryTitle = (productPerCategory: OrganizationProductPerCategoryApi, t: TFunction) => {
	switch (productPerCategory.category) {
		case "License":
			return t("modules.organization.field.licenses.title", { ns: "admin" });
		case "Rent":
			return t("modules.organization.field.rent.title", { ns: "admin" });
		default:
			return "";
	}
};
